import axios from "axios";
import { defaultHeader } from "../constants/defaultItems";
import { toast } from "@/components/ui/use-toast";
import { BUSY_CALLERS_CHANGE } from "../reducers/types";
const baseUrl = "/api/UserAccount/";

export const registerUser = (payload, callback) => (dispatch) => {
  axios
    .post(baseUrl + "Register", payload, defaultHeader)
    .then(function (resp) {
      console.log("resp ", resp);
      if (resp.status === 200) {
        callback && callback(resp.data);
      } else {
        callback && callback(null);
        toast({
          variant: "destructive",
          title: "error",
          description: resp.data?.Message ?? "Failed from API",
        });
      }
    })
    .catch(function (error) {
      callback && callback(false);
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message,
      });
    });
};
export const login = (payload, callback) => (dispatch) => {
  axios
    .post(baseUrl + "Login", payload, defaultHeader)
    .then(function (resp) {
      var isSuccess = false;
      var token = "";
      if (resp.status === 200) {
        let data = resp.data;
        if (data.IsAuthenticate) {
          token = data.AccessToken;
          localStorage.setItem("refreshToken", data.RefreshToken);
          localStorage.setItem(
            "refreshTokenExpTime",
            data.RefreshTokenExpireMinute
          );
          localStorage.setItem("userName", data.Result.UserName);
          localStorage.setItem("fullName", data.Result.FullName);
          isSuccess = true;
        }
      } else {
        toast({
          variant: "destructive",
          title: resp.status ?? "error",
          description: resp.statusText ?? "Failed from API",
        });
      }
      callback && callback(isSuccess, token);
    })
    .catch(function (error) {
      toast({
        variant: "destructive",
        title: error.name,
        description: error.message,
      });
    });
};

export const WhoAmI = (callback) => (dispatch) => {
  axios.get(baseUrl + "WhoAmI", defaultHeader).then((resp) => {
    if (resp && resp.data && resp.data.IsSuccess) {
      callback && callback(resp.data.Result);
    } else {
      callback && callback(null);
    }
    dispatch({
      type: BUSY_CALLERS_CHANGE,
      payload: {
        key: resp.config.url,
        isBusy: false,
      },
    });
  }).catch(function (ex) {
    callback && callback(null);
  });
};

export const forgotPassword = (postData, callback) => (dispatch) => {
  axios.post(baseUrl + 'ForgotPassword', postData, defaultHeader).then((resp) => {
    if (resp.data.IsSuccess) {
      toast({
        variant: "success",
        title: 'Success',
        description: resp.data.Message,
      });
      callback && callback(true);
    }
    else {
      callback && callback(false, resp.data.Message);
    }
  })

}

export const CheckRecoveryToken = (postData, callback) => (dispatch) => {
  axios.post(baseUrl + "CheckRecoveryToken", postData, defaultHeader).then((resp) => {
    if (resp.data.IsSuccess) {
      callback && callback(true);
    }
    else {
      toast({
        variant: "destructive",
        title: "error",
        description: resp.data.Message ?? "Failed to check OTP",
      });
      callback && callback(false);
    }
  })
}

export const ResetPassword = (postData, callback) => (dispatch) => {
  axios.post(baseUrl + "ResetPassword", postData, defaultHeader).then((resp) => {
    if (resp.data.IsSuccess) {
      toast({
        variant: "success",
        title: 'Success',
        description: resp.data.Message,
      });
      callback && callback(true);
    }
    else {
      callback && callback(false);

    }
  })
}

export const SociaLogin = (provider, deviceInfo, deviceType, callback) => (dispatch) => {
  axios.get(`/TravelApi/ExternalLogin?provider=${provider}&deviceInfo=${deviceInfo}&deviceType=${deviceType}`).then((resp) => {
    debugger;
    if (resp.status === 200) {
      let data = resp.data;
      callback && callback(data);

    } else {
      toast({
        variant: "destructive",
        title: resp.status ?? "error",
        description: resp.statusText ?? "Failed from API",
      });
    }
  }).catch(function (error) {
    toast({
      variant: "destructive",
      title: error.name,
      description: error.message,
    });
  });
}